/* eslint-disable max-len */
/*
    { method: '', url: '', headers: ({} }
    (path) => ({ method: '', url: '', headers: ({} })
*/

/**
 * 將 params 轉為 query string
 * From:
 * { orderSearch: 'test', statusType: 'test' }
 * To:
 * orderSearch=test&statusType=test
 */
const makeParamsToString = (params) => {
    if (!params || Object.keys(params).length === 0) {
        return '';
    }

    let paramsStr = '';
    Object.keys(params).forEach((key) => {
        if (params[key] && params[key].length > 0) {
            paramsStr += `${key}=${encodeURIComponent(params[key])}&`;
        }
    });
    return paramsStr;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    /* init */
    getStaffToken: ({ method: 'get', url: 'staff/token' }),
    getWebPage: ({ method: 'get', url: 'web-page' }),
    getStaffMenus: ({ method: 'get', url: 'staff/menus' }),
    getStaff: ({ method: 'get', url: 'staff' }),
    getCompanies: ({ method: 'get', url: 'company' }),
    getRegions: ({ method: 'get', url: 'regions' }),
    /* permission */
    getStaffPermission: ({ method: 'get', url: 'staff/permissions/web-page' }),
    postStaffPermission: ({ method: 'post', url: 'staff/permissions/web-page' }),
    patchStaffPermission: ({ id }) => ({ method: 'patch', url: `staff/permissions/web-page/${id}` }),
    deleteStaffPermission: ({ id }) => ({ method: 'delete', url: `staff/permissions/web-page/${id}` }),
    /* staff job position info */
    getStaffJobPositionInfo: ({ method: 'get', url: 'staff/job_position_info' }),
    postStaffJobPositionInfo: ({ method: 'post', url: 'staff/job_position_info' }),
    patchStaffJobPositionInfo: ({ id }) => ({ method: 'patch', url: `staff/job_position_info/${id}` }),
    deleteStaffJobPositionInfo: ({ id }) => ({ method: 'delete', url: `staff/job_position_info/${id}` }),
    /* monitor */
    getDashboard: ({ method: 'get', url: 'cars/dashboard' }),
    getMonitorTasks: ({ method: 'get', url: 'cars/monitor/tasks' }),
    getMonitorOperations: ({ method: 'get', url: 'cars/monitor/operations' }),
    getGpsCars: ({ method: 'get', url: 'cars/gps' }),
    /* reports */
    getReports: ({ method: 'get', url: 'government/reports' }),
    /* member */
    getMembers: ({ method: 'get', url: 'members' }),
    getMember: ({ id }) => ({ method: 'get', url: `members/${id}` }),
    getMemberPhoto: ({ id }) => ({ method: 'get', url: `web/members/photos/${id}` }),
    patchMemberPhoneNumber: ({ id }) => ({ method: 'patch', url: `members/${id}/phone-number` }),
    patchMemberStatus: ({ id }) => ({ method: 'patch', url: `members/${id}/status` }),
    getMemberRatingLogs: ({ id }) => ({ method: 'get', url: `members/${id}/rating-item/log` }),
    postMemberRatingLog: ({ method: 'post', url: 'members/rating/score' }),
    getMemberLogs: ({ id }) => ({ method: 'get', url: `members/${id}/log` }),
    postMemberLog: ({ id }) => ({ method: 'post', url: `members/${id}/log` }),
    deleteMemberLog: ({ id }) => ({ method: 'delete', url: `members/${id}/log` }),
    getMemberBonusLogs: ({ id }) => ({ method: 'get', url: `members/${id}/bonus/log` }),
    /* blacklist */
    getBlacklist: ({ method: 'get', url: 'blacklist' }),
    postBlacklistCheck: ({ method: 'post', url: 'web/members/blacklist/check' }),
    postBlacklist: ({ method: 'post', url: 'web/members/blacklist' }),
    /* member backup */
    getMemberBackupList: ({ method: 'get', url: 'members/backup' }),
    getMemberBackup: ({ id }) => ({ method: 'get', url: `members/backup/${id}` }),
    /* rating */
    getRatingRules: ({ method: 'get', url: 'members/rating-rule/' }),
    patchRatingRule: ({ method: 'patch', url: 'members/rating-rule/' }),
    getRatingRuleLogs: ({ method: 'get', url: 'members/rating-rule/logs' }),
    getRatingItems: ({ method: 'get', url: 'members/rating-items' }),
    patchRatingItem: ({ method: 'patch', url: 'members/rating-items' }),
    getRatingItemLogs: ({ method: 'get', url: 'members/rating-items/log' }),
    /* station */
    // getStations: ({ method: 'get', url: 'rentals/stations' }),
    getStations: ({ method: 'get', url: 'stations' }),
    getStation: ({ id }) => ({ method: 'get', url: `rentals/stations/${id}` }),
    postStation: ({ method: 'post', url: 'rentals/stations' }),
    patchStation: ({ id }) => ({ method: 'patch', url: `rentals/stations/${id}` }),
    deleteStation: ({ id }) => ({ method: 'delete', url: `rentals/stations/${id}` }),
    getStationSelects: ({ method: 'get', url: 'rentals/stations/dropdown' }),
    getStationPhoto: ({ id }) => ({ method: 'get', url: `web/stations/photos/${id}` }),
    postStationPhoto: ({ id }) => ({ method: 'post', url: `web/stations/${id}/photos` }),
    postStationBatch: ({ method: 'post', url: 'rentals/stations/batch' }),
    /* station group */
    getStationGroup: ({ method: 'get', url: 'rentals/station/groups/details' }),
    getStationGroupNames: ({ method: 'get', url: 'rentals/station/groups/names' }),
    postStationGroup: ({ method: 'post', url: 'rentals/station/groups' }),
    patchStationGroup: ({ stationGroupId }) => ({ method: 'patch', url: `rentals/station/groups/${stationGroupId}` }),
    deleteStationGroup: ({ stationGroupId }) => ({ method: 'delete', url: `rentals/station/groups/${stationGroupId}` }),
    /* third party parking lot */
    getThirdPartyParkingLot: () => ({ method: 'get', url: 'rentals/stations/third-party' }),
    /* station owner */
    getStationOwners: ({ method: 'get', url: 'rentals/stations/owners' }),
    postStationOwner: ({ method: 'post', url: 'rentals/stations/owners' }),
    patchStationOwner: ({ id }) => ({ method: 'patch', url: `rentals/stations/owners/${id}` }),
    deleteStationOwner: ({ id }) => ({ method: 'delete', url: `rentals/stations/owners/${id}` }),
    /* car model */
    getCarBrands: ({ method: 'get', url: 'rentals/car-brands' }),
    postCarBrand: ({ method: 'post', url: 'rentals/car-brands' }),
    patchCarBrand: ({ id }) => ({ method: 'patch', url: `rentals/car-brands/${id}` }),
    // getCarModelAll: ({ method: 'get', url: 'rentals/car-models' }),
    getCarModelAll: ({ method: 'get', url: 'car-models' }),
    getCarModels: ({ method: 'get', url: 'rentals/car-models/brands' }),
    postCarModel: ({ method: 'post', url: 'rentals/car-models' }),
    patchCarModel: ({ id }) => ({ method: 'patch', url: `rentals/car-models/${id}` }),
    getCarModelSelects: ({ method: 'get', url: 'rentals/car-models/dropdown' }),
    getCarModelPhoto: ({ id }) => ({ method: 'get', url: `web/car-models/photos/${id}` }),
    postCarModelPhoto: ({ id }) => ({ method: 'post', url: `web/car-models/photos/${id}` }),
    getCarModelPrices: ({ modelId }) => ({ method: 'get', url: `rentals/car-models/${modelId}/price` }),
    postCarModelPrice: ({ modelId }) => ({ method: 'post', url: `rentals/car-models/${modelId}/price` }),
    patchCarModelPrice: ({ modelId, id }) => ({ method: 'patch', url: `rentals/car-models/${modelId}/price/${id}` }),
    getCarModelLogs: ({ id }) => ({ method: 'get', url: `rentals/car-models/${id}/log` }),
    getStayTime: ({ method: 'get', url: 'stay-time/settings' }),
    /* car mileage */
    getCarMileages: ({ method: 'get', url: 'rentals/car-mileage-class' }),
    postCarMileage: ({ method: 'post', url: 'rentals/car-mileage-class' }),
    getCarMileageLogs: ({ method: 'get', url: 'rentals/car-mileage-class/log' }),
    /* car insurance */
    getCarInsurances: ({ method: 'get', url: 'rentals/car-insurances' }),
    postCarInsurance: ({ method: 'post', url: 'rentals/car-insurances' }),
    patchCarInsurance: ({ id }) => ({ method: 'patch', url: `rentals/car-insurances/${id}` }),
    deleteCarInsurance: ({ id }) => ({ method: 'delete', url: `rentals/car-insurances/${id}` }),
    getCarInsuranceLogs: ({ id }) => ({ method: 'get', url: `rentals/car-insurances/${id}/log` }),
    /* extra fee */
    getExtraFees: ({ method: 'get', url: 'rentals/extra-fees' }),
    postExtraFee: ({ method: 'post', url: 'rentals/extra-fees' }),
    patchExtraFee: ({ id }) => ({ method: 'patch', url: `rentals/extra-fees/${id}` }),
    deleteExtraFee: ({ id }) => ({ method: 'delete', url: `rentals/extra-fees/${id}` }),
    getExtraFeeLogs: ({ id }) => ({ method: 'get', url: `rentals/extra-fees/${id}/log` }),
    /* plan */
    getPlans: ({ method: 'get', url: 'rentals/plans' }),
    postPlan: ({ method: 'post', url: 'rentals/plans' }),
    patchPlan: ({ id }) => ({ method: 'patch', url: `rentals/plans/${id}` }),
    deletePlan: ({ id }) => ({ method: 'delete', url: `rentals/plans/${id}` }),
    /* rent params */
    getParams: ({ method: 'get', url: 'rentals/params' }),
    patchParam: ({ method: 'patch', url: 'rentals/params' }),
    /* special date */
    getSpecialDates: ({ method: 'get', url: 'rentals/special-date' }),
    postSpecialDate: ({ method: 'post', url: 'rentals/special-date' }),
    patchSpecialDate: ({ id }) => ({ method: 'patch', url: `rentals/special-date/${id}` }),
    deleteSpecialDate: ({ id }) => ({ method: 'delete', url: `rentals/special-date/${id}` }),
    /* car */
    getCars: ({ method: 'get', url: 'cars' }),
    getCarBasic: ({ id }) => ({ method: 'get', url: `cars/${id}/basic` }),
    getCarData: ({ id }) => ({ method: 'get', url: `cars/${id}/data` }),
    getCarStatus: ({ id }) => ({ method: 'get', url: `cars/${id}/status` }),
    getCarDeviceStatus: ({ id }) => ({ method: 'get', url: `cars/${id}/device-status` }),
    getCarLogs: ({ id }) => ({ method: 'get', url: `cars/${id}/log-odb` }),
    getCarTroubleCodes: ({ id }) => ({ method: 'get', url: `cars/${id}/trouble-code` }),
    patchCar: ({ id }) => ({ method: 'patch', url: `cars/${id}` }),
    getCarPhoto: ({ id }) => ({ method: 'get', url: `web/cars/photos/${id}` }),
    postCarPhoto: ({ id }) => ({ method: 'post', url: `web/cars/photos/${id}` }),
    postCarBusinessStatus: ({ id }) => ({ method: 'post', url: `cars/${id}/business-status`, headers: { 'Content-Type': 'application/json' } }),
    postCarCommandLock: ({ id }) => ({ method: 'post', url: `cars/${id}/commands/lock` }),
    postCarCommandUnlock: ({ id }) => ({ method: 'post', url: `cars/${id}/commands/unlock` }),
    postCarCommandTurnOn: ({ id }) => ({ method: 'post', url: `cars/${id}/commands/turn-on` }),
    postCarCommandTurnOff: ({ id }) => ({ method: 'post', url: `cars/${id}/commands/turn-off` }),
    postCarCommandWakeUp: ({ id }) => ({ method: 'post', url: `cars/${id}/commands/wake-up` }),
    postCarCommandWhere: ({ id }) => ({ method: 'post', url: `cars/${id}/commands/where` }),
    /* car repair */
    getCarRepairs: ({ method: 'get', url: 'cars/repairs' }),
    postCarRepair: ({ method: 'post', url: 'cars/repairs' }),
    patchCarRepair: ({ id }) => ({ method: 'patch', url: `cars/repairs/${id}` }),
    patchCarRepairCancel: ({ id }) => ({ method: 'patch', url: `cars/repairs/${id}/cancel` }),
    /* order */
    getOrders: ({ method: 'get', url: 'orders' }),
    getOrder: ({ id }) => ({ method: 'get', url: `orders/${id}` }),
    patchOrderNote: ({ id }) => ({ method: 'patch', url: `orders/${id}/note`, headers: { 'Content-Type': 'text/plain' } }),
    getOrderEstimatedPrice: ({ method: 'get', url: 'orders/price' }),
    getOrderActualPrice: ({ id }) => ({ method: 'get', url: `orders/${id}/price` }),
    postOrderItem: ({ id }) => ({ method: 'post', url: `web/orders/${id}/items` }),
    getOrderExtraItems: ({ id }) => ({ method: 'get', url: `orders/${id}/extra-items` }),
    postOrderExtraItem: ({ id }) => ({ method: 'post', url: `web/orders/${id}/extra-items` }),
    getOrderPayments: ({ id }) => ({ method: 'get', url: `orders/${id}/payment` }),
    getOrderInvoices: ({ id }) => ({ method: 'get', url: `orders/${id}/invoice` }),
    getOrderDebitNotes: ({ id }) => ({ method: 'get', url: `orders/${id}/invoice/debit-note` }),
    getOrderPaymentItems: ({ orderId, id }) => ({ method: 'get', url: `orders/${orderId}/payment/${id}/items` }),
    getOrderRefundAvailable: ({ orderId, id }) => ({ method: 'get', url: `orders/${orderId}/payment/${id}/refund-available` }),
    postOrderRefund: ({ id }) => ({ method: 'post', url: `orders/${id}/items/refund` }),
    postOrderInvoiceResend: ({ orderId, id }) => ({ method: 'post', url: `orders/${orderId}/invoice/${id}/resend` }),
    postOrderInvoiceDebitNoteResend: ({ orderId, id }) => ({ method: 'post', url: `orders/${orderId}/invoice/${id}/debit-note/resend` }),
    postOrderInvoiceChange: ({ orderId, id }) => ({ method: 'post', url: `orders/${orderId}/invoice/${id}/change` }),
    patchOrderInvoiceReply: ({ orderId, id, status }) => ({ method: 'patch', url: `orders/${orderId}/invoice/${id}/reply/${status}` }),
    postOrderSpecialDropOff: ({ id }) => ({ method: 'post', url: `orders/${id}/special-drop-off` }),
    deleteOrderSpecialDropOff: ({ id }) => ({ method: 'delete', url: `orders/${id}/special-drop-off` }),
    getOrderLogs: ({ id }) => ({ method: 'get', url: `orders/${id}/log` }),
    postOrderLog: ({ id }) => ({ method: 'post', url: `orders/${id}/log`, headers: { 'Content-Type': 'text/plain' } }),
    deleteOrderLog: ({ id }) => ({ method: 'delete', url: `orders/${id}/log`, headers: { 'Content-Type': 'application/json' } }),
    getOrderTrafficTickets: ({ method: 'get', url: 'accounting/traffic-ticket/orders' }),
    /* traffic ticket */
    getTrafficTickets: ({ method: 'get', url: 'accounting/traffic-ticket' }),
    postTrafficTicket: ({ method: 'post', url: 'accounting/traffic-ticket' }),
    patchTrafficTicket: ({ id }) => ({ method: 'patch', url: `accounting/traffic-ticket/${id}` }),
    deleteTrafficTicket: ({ id }) => ({ method: 'delete', url: `accounting/traffic-ticket/${id}` }),
    patchTrafficTicketManualProcessing: ({ method: 'patch', url: 'accounting/traffic-ticket/manual-processing' }),
    patchTrafficTicketSelfPay: ({ method: 'patch', url: 'accounting/traffic-ticket/self-pay' }),
    patchTrafficTicketRemittance: ({ method: 'patch', url: 'accounting/traffic-ticket/collect-remit/remittance' }),
    patchTrafficTicketCollectRemit: ({ method: 'patch', url: 'accounting/traffic-ticket/collect-remit' }),
    patchTrafficTicketTransferFine: ({ method: 'patch', url: 'accounting/traffic-ticket/transfer-fine' }),
    postTrafficTicketPhoto: ({ method: 'post', url: 'web/contents/traffic-ticket' }),
    postTrafficTicketPhotoDownload: ({ method: 'post', url: 'web/contents/traffic-ticket/download' }),
    /* receivable */
    getReceivables: ({ method: 'get', url: 'accounting/receivable' }),
    /* received */
    getReceives: ({ method: 'get', url: 'accounting/received' }),
    postReceive: ({ method: 'post', url: 'accounting/received' }),
    patchReceive: ({ id }) => ({ method: 'patch', url: `accounting/received/${id}` }),
    deleteReceive: ({ id }) => ({ method: 'delete', url: `accounting/received/${id}` }),
    postReceiveBatch: ({ method: 'post', url: 'accounting/received/batch' }),
    getReceiveDetails: ({ id }) => ({ method: 'get', url: `accounting/received/${id}/detail` }),
    postReceiveDetail: ({ id }) => ({ method: 'post', url: `accounting/received/${id}/detail` }),
    patchReceiveDetail: ({ id }) => ({ method: 'patch', url: `accounting/received/${id}/detail` }),
    postReceiveReimburse: ({ id }) => ({ method: 'post', url: `accounting/received/${id}/reimburse` }),
    /* collection */
    getCollections: ({ method: 'get', url: 'accounting/collection' }),
    patchCollectionSendSMS: ({ method: 'patch', url: 'accounting/collection/send-sms' }),
    patchCollectionTransferStation: ({ method: 'patch', url: 'accounting/collection/transfer-station' }),
    /* banner */
    getBanners: ({ method: 'get', url: 'marketing/banners' }),
    getBannerFiles: ({ method: 'get', url: 'marketing/banners/files' }),
    getBannerFile: ({ id }) => ({ method: 'get', url: `marketing/banners/files/${id}` }),
    postBanner: ({ method: 'post', url: 'marketing/banners' }),
    patchBanner: ({ id }) => ({ method: 'patch', url: `marketing/banners/${id}` }),
    deleteBanner: ({ id }) => ({ method: 'delete', url: `marketing/banners/${id}` }),
    postBannerFile: ({ method: 'post', url: 'web/marketing/banners' }),
    patchBannerFile: ({ method: 'patch', url: 'web/marketing/banners' }),
    patchBannerSort: ({ method: 'patch', url: 'marketing/banners/sort' }),
    /* coupon */
    getCoupons: ({ method: 'get', url: 'coupons' }),
    postCoupon: ({ method: 'post', url: 'coupons' }),
    patchCoupon: ({ id }) => ({ method: 'patch', url: `coupons/${id}` }),
    deleteCoupon: ({ id }) => ({ method: 'delete', url: `coupons/${id}` }),
    /* coupon condition tags */
    getTags: ({ method: 'get', url: 'tags' }),
    /* invite code */
    getInviteCodes: ({ method: 'get', url: 'coupons/types' }),
    getInviteCodeLogs: ({ method: 'get', url: 'coupons/logs' }),
    /* report */
    getPerformanceReports: ({ method: 'get', url: 'reports/performance' }),
    getOrderReports: ({ method: 'post', url: 'reports/orders' }),
    getPlanUsageReports: ({ method: 'get', url: 'reports/plan-usage' }),
    getCouponRedemptionReports: ({ method: 'get', url: 'reports/coupon-redemption' }),
    getCouponUsageReports: ({ method: 'get', url: 'reports/coupon-usage' }),
    getReportOrders: ({ method: 'get', url: 'reports/orders/detail' }),
    getReportMembers: ({ method: 'get', url: 'reports/members/detail' }),
    getTemporaryReports: (query) => ({ method: 'get', url: `reports/parking-records/${makeParamsToString(query)}` }),
    /* car schedule */
    getCarSchedule: ({ method: 'get', url: 'car-schedule' }),
    patchOrderChangeCar: ({ method: 'patch', url: 'car-schedule/order-change-car' }),
    /* task ticket */
    getTaskTickets: ({ method: 'get', url: 'task-tickets' }),
    getTaskTicket: ({ id }) => ({ method: 'get', url: `task-tickets/${id}` }),
    postTaskTicket: ({ method: 'post', url: 'task-tickets' }),
    patchTaskTicket: ({ id }) => ({ method: 'patch', url: `task-tickets/${id}` }),
    getTaskTicketFeedbackTypes: ({ method: 'get', url: 'task-tickets/feedback-types' }),
    getTaskTicketPhotos: ({ id }) => ({ method: 'get', url: `web/task-tickets/${id}/photos` }),
    patchTaskTicketFeedback: ({ method: 'patch', url: 'task-tickets/feedback/batch' }),
    /* work order */
    getWorkOrders: ({ method: 'get', url: 'maintenance/work-orders' }),
    postWorkOrder: ({ method: 'post', url: 'maintenance/work-orders' }),
    patchWorkOrder: ({ id }) => ({ method: 'patch', url: `maintenance/work-orders/${id}` }),
    deleteWorkOrder: ({ id }) => ({ method: 'delete', url: `maintenance/work-orders/${id}` }),
    /* technician group */
    getTechnicianGroups: ({ method: 'get', url: 'technician-groups' }),
    postTechnicianGroup: ({ method: 'post', url: 'technician-groups' }),
    patchTechnicianGroup: ({ id }) => ({ method: 'patch', url: `technician-groups/${id}` }),
    deleteTechnicianGroup: ({ id }) => ({ method: 'delete', url: `technician-groups/${id}` }),
    /* task score */
    getTaskScores: ({ method: 'get', url: 'task-score' }),
    postTaskScore: ({ method: 'post', url: 'task-score' }),
    getTaskScoreLogs: ({ method: 'get', url: 'task-score/log' }),
    /* technician */
    getTechnicians: ({ method: 'get', url: 'technicians' }),
    postTechnician: ({ method: 'post', url: 'technicians' }),
    patchTechnician: ({ id }) => ({ method: 'patch', url: `technicians/${id}` }),
    deleteTechnician: ({ id }) => ({ method: 'delete', url: `technicians/${id}` }),
    /* customer service */
    getCustomerServiceRecords: ({ method: 'get', url: 'customer-service/contact-us/records' }),
    postCustomerServiceRecord: ({ method: 'post', url: 'customer-service/contact-us/records' }),
    patchCustomerServiceRecord: ({ id }) => ({ method: 'patch', url: `customer-service/contact-us/records/${id}` }),
    getCustomerServiceFile: ({ id }) => ({ method: 'get', url: `web/customer-service/contact-us/${id}/files` }),
    postCustomerServiceFile: ({ id }) => ({ method: 'post', url: `web/customer-service/contact-us/${id}/files` }),
    /* article */
    getArticles: ({ method: 'get', url: 'contents/articles' }),
    patchArticleFile: ({ id }) => ({ method: 'patch', url: `web/contents/articles/${id}` }),
    /* faq */
    getFaqs: ({ method: 'get', url: 'contents/faq' }),
    getFaqCategories: ({ method: 'get', url: 'contents/faq/categories' }),
    postFaqCategory: ({ method: 'post', url: 'contents/faq/categories' }),
    patchFaqCategory: ({ id }) => ({ method: 'patch', url: `contents/faq/categories/${id}` }),
    deleteFaqCategory: ({ id }) => ({ method: 'delete', url: `contents/faq/categories/${id}` }),
    patchFaqCategorySort: ({ method: 'patch', url: 'contents/faq/categories/sort' }),
    postFaq: ({ method: 'post', url: 'contents/faq' }),
    patchFaq: ({ id }) => ({ method: 'patch', url: `contents/faq/${id}` }),
    deleteFaq: ({ id }) => ({ method: 'delete', url: `contents/faq/${id}` }),
    patchFaqSort: ({ method: 'patch', url: 'contents/faq/sort' }),
    /* notification */
    getManualNotifications: ({ method: 'get', url: 'notifications/details/manual/not-scheduled' }),
    getSystemNotifications: ({ method: 'get', url: 'notifications/settings/system' }),
    getManualScheduledNotifications: ({ method: 'get', url: 'notifications/details/manual/scheduled' }),
    postNotification: ({ method: 'post', url: 'notifications/settings' }),
    patchNotification: ({ id }) => ({ method: 'patch', url: `notifications/settings/${id}` }),
    deleteNotification: ({ id }) => ({ method: 'delete', url: `notifications/settings/${id}` }),
    postNotificationDetail: ({ method: 'post', url: 'notifications/details/main' }),
    patchNotificationDetail: ({ id }) => ({ method: 'patch', url: `notifications/details/main/${id}` }),
    getSystemNotificationLogs: ({ method: 'get', url: 'notifications/logs' })
};
